import { StyleSheet } from 'react-native';
import { dimensions, colors } from '../../../../styles';

export default StyleSheet.create({
  primaryButtonContainer: {
    backgroundColor: colors.white,
    borderColor: colors.grayLight,
  },
  buttonContainer: {
    // transform: [{ scaleX: -1 }],
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: 40,
    marginHorizontal: 4,
    height: 28,
    paddingLeft: dimensions.halfMedium,
    borderRadius: 14,
    borderWidth: 1,
  },
  squareContainer: {
    borderRadius: 5,
  },
  icon: {
    paddingHorizontal: dimensions.halfMedium,
    paddingTop: 2,
  },
});
